import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../../api/config";
import { HTTP_STATUS } from "../../../app/constants";

const namespace = "login";

const initialState = {
  loading: null,
  loginResponse: {},
  loginUser: null,
  errorMessage: null,
};

// PATCH
export const validateUserCredentials = createAsyncThunk(
  `${namespace}/validateUserCredentials`,
  async (userInfo) => {
    const response = await api.patch("/signin", userInfo);
    if (response.headers["auth"] !== undefined) {
      sessionStorage.setItem("auth", JSON.stringify(response.headers["auth"]));
    }
    return response.data;
  }
);

//GET
export const getSignInUserFromServer = createAsyncThunk(
  `${namespace}/getSignInUserFromServer`,
  async () => {
    const response = await api.get("/signinuser", {
      headers: { auth: `${JSON.parse(sessionStorage.getItem("auth"))}` },
    });
    return response.data;
  }
);

export const loginSlice = createSlice({
  name: namespace,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(validateUserCredentials.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(validateUserCredentials.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.loginResponse = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(validateUserCredentials.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.loginResponse = {};
        state.errorMessage = error.message;
      })
      .addCase(getSignInUserFromServer.pending, (state) => {
        state.loading = HTTP_STATUS.PENDING;
      })
      .addCase(getSignInUserFromServer.fulfilled, (state, action) => {
        state.loading = HTTP_STATUS.FULFILLED;
        state.loginUser = action.payload.data;
        state.errorMessage = null;
      })
      .addCase(getSignInUserFromServer.rejected, (state, { error }) => {
        state.loading = HTTP_STATUS.REJECTED;
        state.loginUser = null;
        state.errorMessage = error.message;
      });
  },
});

export const getSignInUser = (state) => state.login.loginUser;
export const selectLoadingStatus = (state) => state.login.loading;
export default loginSlice.reducer;
